import React, { useState, useEffect } from 'react';
import { IsError } from './Utility/IsError';

interface IconProps {
    Name: string;
    Classes?: string;
    Filled?: boolean;
    Pointer?: boolean;
    OnClick?: () => void;
    Count?: number;
    Tooltip?: string;
    style?: React.CSSProperties;
}

interface IconsData {
    [key: string]: { value: string };
}

interface BootstrapTooltip {
    new (element: Element): unknown;
}

interface BootstrapWindow extends Window {
    bootstrap?: {
        Tooltip: BootstrapTooltip;
    };
}

export const SCIcon: React.FC<IconProps> = ({ Name, Classes = '', Filled = false, Pointer = false, OnClick, Count, Tooltip, style }) => {
    const [icons, setIcons] = useState<IconsData | null>(null);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchIcons = async () => {
            try {
                const response = await fetch('/Icons.json');
                if (!response.ok) {
                    throw new Error(`Failed to fetch icons: ${response.statusText}`);
                }
                const data: IconsData = await response.json();
                setIcons(data);
            } catch (err) {
                if (IsError(err)) {
                    setError(err.message);
                } else {
                    setError('An unknown error occurred');
                }
            }
        };

        fetchIcons();
    }, []);

    useEffect(() => {
        const bootstrap = (window as BootstrapWindow).bootstrap;
        if (Tooltip && bootstrap) {
            const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
            tooltipTriggerList.forEach((tooltipTriggerEl) => {
                new bootstrap.Tooltip(tooltipTriggerEl);
            });
        }
    }, [Tooltip]);

    if (error) return <span>Error: {error}</span>;

    const icon = icons?.[Name] || { value: Name };
    const _Filled = Filled ? { fontVariationSettings: "'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 48", ...style } : {};
    const _Role = Pointer ? "button" : "";

    return (
        <div className="icon-container" style={{ position: 'relative', display: 'inline-block', ...style }}>
            <span
                className={`material-symbols-outlined ${Classes}`}
                style={_Filled}
                role={_Role}
                onClick={OnClick}
                data-bs-toggle={Tooltip ? "tooltip" : undefined}
                title={Tooltip || ""}>
                {icon.value}
            </span>
            {Count !== undefined && Count > 0 && (
                <span className="icon-badge">{Count}</span>
            )}
        </div>
    );
};

export default SCIcon;
